import script from "./CardInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CardInfo.vue?vue&type=script&setup=true&lang=js"

import "./CardInfo.vue?vue&type=style&index=0&id=218987a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-218987a5"]])

export default __exports__